<template>
  <div class="delivery-collection-kpi-drill-through-main">
    <div class="drill-through-body">
      <TableBox :title="tableTitle" :tableData="drillThroughDetails" :dataType="tableDataType" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
  },
  data: function() {
    return {
      drillThroughDetails: [],
      drillThroughType: '',
      tableTitle: '',
      tableDataType: {
        'Request Time': 'date',
        'Required Time': 'date',
        'GatePass Time': 'date',
        'Delivery Time': 'date',
        'RFC Time': 'date',
        'Collection Time': 'date',
      },
    };
  },
  props: {
  },
  methods: {
  },
  async mounted() {
    this.$fullscreenLoading('Getting details');
    var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
    var postObject = details.data;
    var drillThrough = await this.$apiCallV2('/DeliveryCollectionKpi/GetDelColOnTimeAnalysis2', postObject);
    this.$fullscreenLoading();

    this.drillThroughDetails = drillThrough;
    this.drillThroughType = this.$route.params.drillThroughName.split('-')[1].trim().split(' ')[0].trim();

    if (this.drillThroughType == 'DEL_JOB') {
      this.tableTitle = `On Time Delivery KPI Report`;
    } else {
      this.tableTitle = `On Time Collection KPI Report`;
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.delivery-collection-kpi-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>